import { create } from 'zustand';
import { moduleService } from '@/services/superAdmin/moduleService';

export const useModuleStore = create((set) => ({
  availableModules: [],
  assignedModules: [],
  loading: false,
  error: null,

  fetchAvailableModules: async () => {
    set({ loading: true, error: null });
    try {
      const res = await moduleService.getAvailableModules();
      set({ availableModules: res.data, loading: false });
    } catch (err) {
      set({ error: err.message, loading: false });
    }
  },

  fetchAssignedModules: async (schoolId) => {
    set({ loading: true, error: null });
    try {
      const res = await moduleService.getAssignedModules(schoolId);
      set({ assignedModules: res.data, loading: false });
    } catch (err) {
      set({ error: err.message, loading: false });
    }
  },

  assignModules: async (schoolId, moduleInternalNames) => {
    set({ loading: true, error: null });
    try {
      await moduleService.assignModulesToSchool(schoolId, moduleInternalNames);
      set({ loading: false });
      return true;
    } catch (err) {
      set({ error: err.message, loading: false });
      throw err;
    }
  }
}));
